import React from 'react';
import type ProductsJsmEmailRequestsType from '@atlassian/jira-spa-apps-products-jsm-email-requests/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProductsJsmEmailRequests = lazyForPaint<typeof ProductsJsmEmailRequestsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-products-jsm-email-requests", jiraSpaEntry: "async-products-jsm-email-requests" */ '@atlassian/jira-spa-apps-products-jsm-email-requests'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyProductsJsmEmailRequests}
		pageId="products-jsm-email-requests"
		shouldShowSpinner={false}
	/>
);
